import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zh",
  "use": "icon-zh-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zh\"><path d=\"M528 128a16 16 0 0 1 16 16V288h272a16 16 0 0 1 16 16v352a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16l-0.064-48H544v272a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V608H255.936l0.064 48a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-352a16 16 0 0 1 12.352-15.552L208 288H480V144A16 16 0 0 1 496 128h32zM480 352H256l-0.064 192H480v-192z m287.936 0H544v192h223.936v-192z\" fill=\"#515151\" p-id=\"3424\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol